import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";

// Async Thunk for fetching lookup data
export const fetchLookupData = createAsyncThunk(
  "lookup/fetchLookupData",
  async ({ lookupNumber, parentId, language, customerFk, allowNotSelectedUnitsOnly }, { rejectWithValue }) => {
    try {
      // Build the payload dynamically
      const payload = {
        lookupNumber: lookupNumber,
        parentId: parentId,
      };

      // Add customerFk to the payload only if it is not null
      if (allowNotSelectedUnitsOnly !== null) {
        payload.allowNotSelectedUnitsOnly = allowNotSelectedUnitsOnly;
      }
      if (customerFk !== null) {
        payload.customerFk = customerFk;
      }
      const response = await axiosInstance.post(
        "/api/Lookups/CommonLookupDropDown",
        payload,
        {
          headers: {
            "lang": language === "English" ? "2" : "1",
          },
        }
      );

      return { lookupNumber, data: response.data.message };
    } catch (error) {
      console.error("Error fetching lookup data:", error); // Log the error
      return rejectWithValue(error.response?.data || "Error fetching lookup data");
    }
  }
);

const lookupSlice = createSlice({
  name: "lookup",
  initialState: {
    lookups: {}, // Stores lookup data by lookupNumber
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLookupData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLookupData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.lookups[payload.lookupNumber] = payload.data;
      })
      .addCase(fetchLookupData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default lookupSlice.reducer;
